export const ProductOfferingKinds = {
  BASE: 'BASE',
  ADDON: 'ADD-ON',
} as const;

export type ProductOfferingKind = (typeof ProductOfferingKinds)[keyof typeof ProductOfferingKinds];

export const ProductAddOnTypes = {
  BRANDING: 'branding',
  SUPPORT: 'support',
  API_INTEGRATION: 'api_integration',
  RECIPIENT: 'recipient',
} as const;

export type ProductAddOnType = (typeof ProductAddOnTypes)[keyof typeof ProductAddOnTypes];

export enum PaymentMethod {
  CARD = 'card',
  BANK_ACCOUNT = 'us_bank_account',
}

export enum BillingPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export interface ProductOfferingPrice {
  id: string;
  name: string;
  billing_period: BillingPeriod;
  amount: number;
}

export interface ProductOffering {
  id: string;
  name: string;
  description: string;
  kind: ProductOfferingKind;
  prices: ProductOfferingPrice[];
}

export type ProductOfferingPriceMap = {
  [key in BillingPeriod]: ProductOfferingPrice;
};

export interface LocalProductOffering extends ProductOffering {
  addOnType: ProductAddOnType;
  priceMap: ProductOfferingPriceMap;
  isSubscribed?: boolean;
  quantity?: number;
}

export interface LocalProductOfferingPrice extends ProductOfferingPrice {
  isYearly: boolean;
}

export interface SelectedProductLineItem {
  id: string;
  price_id: string;
  quantity: number;
}

export interface ProductSubscription {
  subscription_id?: string;
  line_items: SelectedProductLineItem[];
  default_payment_method: PaymentMethod;
  last_4_digits: string;
}

export interface PlanTotals {
  monthly: string;
  yearly: string;
  basePlan: {
    monthly: string;
    yearly: string;
  };
  annualPerMonth: string;
  current: string;
}
